
import { AwsDocument } from "@/models/base/aws-document";
import { AWSFileService } from "@/services";
import Vue from "vue";
import AppAwsFilesInfo from "./AwsFilesInfo.vue";
import { BrowserInfo } from "@/utils/browser";

export default Vue.extend({
	props: {
		files: {
			type: Array as ()=>AwsDocument[],
			required: true
		},
	},
	methods: {
		close(){
			this.$emit("close");
		}
	},
	async mounted(){
		if (this.files.length == 1 && !BrowserInfo.isElectron()) {
			let file = this.files[0].File;
			if (!file) return;
			let link = await AWSFileService.getLink(file.Token);
			window.open(link, "_blank");
		}
	},
	components: {
		AppAwsFilesInfo
	}
});
